module.exports = __webpack_public_path__ + "f5ab0049c6cc0c26761805a8b7be622f.svg";